

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ColumnDetailFormComponent } from './columndetail-form/columndetail-form.component';
import { ColumnDetailComponent } from './columndetail.component';
import { ColumnDetailRoutes } from './columndetail.routing';

export function declaration() {
    return [ColumnDetailComponent, ColumnDetailFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ColumnDetailModule {
}

@NgModule({
    imports: [ColumnDetailModule, ColumnDetailRoutes],
    exports: [ColumnDetailModule]
})
export class ColumnDetailWithRouteModule {
}
